import { ConversationState, CONVERSATION_INIT_STATE } from './conversation.state';
import { 
    ConversationAction, 
    ConversationActionType, 
    LoadConversationFailedAction, 
    LoadConversationSucceededAction, 
    LoadMessagesFailedAction, 
    LoadMessagesSucceededAction 
} from './conversation.actions';

export function conversationReducer(state: ConversationState = CONVERSATION_INIT_STATE, action: ConversationAction): ConversationState {
    switch (action.type) {
        case ConversationActionType.LOAD_CONVERSATION: {
            return { 
                ...state, 
                isReady                 : false,
                conversation            : null, 
                error                   : null
            };
        }
        case ConversationActionType.LOAD_CONVERSATION_FAILED: {
            return { 
                ...state, 
                isReady                 : true,
                conversation            : null, 
                error                   : (<LoadConversationFailedAction>action.error)
            };
        }
        case ConversationActionType.LOAD_CONVERSATION_SUCCEEDED: {
            return { 
                ...state, 
                isReady                 : true,
                conversation            : (<LoadConversationSucceededAction>action).conversation,
                error                   : null
            };
        }
        case ConversationActionType.LOAD_MESSAGES: {
            return { 
                ...state, 
                messages                : null, 
                error                   : null
            };
        }
        case ConversationActionType.LOAD_MESSAGES_FAILED: {
            return { 
                ...state, 
                messages                : null, 
                error                   : (<LoadMessagesFailedAction>action.error)
            };
        }
        case ConversationActionType.LOAD_MESSAGES_SUCCEEDED: {
            return { 
                ...state, 
                messages                : (<LoadMessagesSucceededAction>action).messages,
                error                   : null
            };
        }
        default:
            return state;
    }
}
